module.exports = __webpack_public_path__ + "static/media/endomondoCloneScreen.3577e67a.jpg";